


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Founder extends Vue {
  @Prop() private msg!: string;
}
